module.exports = __webpack_public_path__ + "media/images/bg/video-button-f3038a9bb5d1c0b712439f28ebffebe7.svg";